import React from "react";
import Skeleton from "react-loading-skeleton";
import { useFetchData } from "../../hooks/useFetchData";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatNumber } from "../../utils/data/essential";

const CollectionCard = ({ locationId }) => {
  const firstdate = moment().startOf("month").format("YYYY-MM-DD");
  const today = moment().format("YYYY-MM-DD");
  // Fetching targets
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  const targetUrl = `reports/monthly?location=${locationId}&month=${month}&year=${year}`;
  const { data: targets } = useFetchData(
    ["fetch-target", locationId],
    targetUrl,
    true
  );
  let target = null;
  if (targets) {
    target = targets.reduce(
      (acc, currentTarget) => currentTarget.currentTargetAmount + acc,
      0
    );
  }
  // Fetch today payments
  const url1 = `reports/collections?location=${locationId}&startdate=${today}&enddate=${today}`;
  const { data: todayPayments } = useFetchData(
    ["fetch-daily-payments", locationId],
    url1,
    true,
  );
  let totalDailyPayments = null;
  totalDailyPayments = todayPayments?.reduce(
    (accumulator, currentPayment) =>
      accumulator + currentPayment.totalCollectedAmount,
    0
  );
  // Fetch monthly payments
  const url = `reports/collections?location=${locationId}&startdate=${firstdate}&enddate=${today}`;
  const { data: monthlyPayments } = useFetchData(
    ["fetch-monthly-payments", locationId],
    url,
    true
  );

  let totalPayments = null;
  if (monthlyPayments) {
    totalPayments = monthlyPayments
      ?.reduce(
        (accumulator, currentPayment) => accumulator + currentPayment.totalCollectedAmount,
        0
      );
  }
  return (
    <div className='card mt-3 dashboard-card-width'>
      <div>
        <div className='d-flex justify-content-center'>
          <h4>Ayakusanijwe</h4>
        </div>
        <div className='d-flex justify-content-between mt-3 flex-column-on-mobile'>
          <div className='d-flex flex-column' style={{ gap: "10" }}>
            <h5 style={{ color: "#696060" }}>Intego</h5>
            <h6
              // className='d-flex justify-content-end'
              style={{ color: "#3a0ca3", fontSize: 20 }}
            >
              <b>{target ? formatNumber(target) + " Rwf" : <Skeleton />}</b>
            </h6>
          </div>
          <Link to={`/loggedin/monthly-payments/${locationId}`}>
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5 style={{ color: "#69060" }}>Uku kwezi</h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                <b>
                  {totalPayments !== null ? (
                    totalPayments && <b>{formatNumber(totalPayments)+ " Rwf"}</b>
                  ) : (
                    <div>
                      <Skeleton />
                    </div>
                  )}
                </b>
              </h6>
            </div>
          </Link>
          <Link to={`/loggedin/daily-payments/${locationId}`}>
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5 style={{ color: "#696060" }}>Uyu munsi</h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                <b>
                  {totalDailyPayments != null ? (
                    <b>{formatNumber(totalDailyPayments) + " Rwf"}</b>
                  ) : (
                    <div>
                      <Skeleton />
                    </div>
                  )}
                </b>
              </h6>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CollectionCard;
